import { toggleClass } from "./utilities";
import { Logger } from "@fruugo/utilities";
import { getSiteNavigationData } from "../modules/api";

const Log = new Logger(window.environment);

export { preloadJson, stickyElement, initAccordion, initToggleClassLinks };

function preloadJson() {
  const event = new CustomEvent("navigationReady");
  if (
    !sessionStorage.getItem("preloadedNavJson") ||
    sessionStorage.getItem("preloadedNavLang") !== window.currentLang
  ) {
    getSiteNavigationData(window.currentLang)
      .then((data) => {
        sessionStorage.setItem("preloadedNavJson", JSON.stringify(data));
        sessionStorage.setItem("preloadedNavLang", window.currentLang);
        window.dispatchEvent(event);
      })
      .catch((error) => Log.error(error));
  } else {
    window.dispatchEvent(event);
  }
}

function stickyElement(selector, activeFrom, activeClass) {
  const stickyElement = document.querySelector(selector);

  window.addEventListener("scroll", function () {
    if (window.pageYOffset >= activeFrom) {
      stickyElement.classList.add(activeClass);
    } else {
      stickyElement.classList.remove(activeClass);
    }
  });
}

function initAccordion() {
  const accordions = document.querySelectorAll(".js-accordion");
  if (accordions) {
    accordions.forEach((el) => {
      const button = el.querySelector("button");
      const container = el.parentNode;
      button.addEventListener("click", () => toggleClass(container, "active"));
    });
  }
}

const initToggleClassLinks = () => {
  const containers = document.querySelectorAll(".js-toggle-class");

  if (containers) {
    containers.forEach((container) => {
      let toggled = false;
      const { toggleElement, toggleCssClass } = container.dataset;
      container.addEventListener("click", () => {
        const elements = document.querySelectorAll(toggleElement);
        elements.forEach((element) => {
          toggleClass(element, toggleCssClass);
        });
        toggled = !toggled;
      });
    });
  }
};
